import type { MediaWrapperContainerTypeEnum } from '@/utils/aspectRatioUtils';
import { getAspectRatioForImages } from '@/utils/aspectRatioUtils';

import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';
import { useDeviceDetect } from '@/hooks/useDeviceDetect';
import { cleanObject } from '@/lib/util';
import { theme } from '@/theme';

import type { CardProps } from '../../types';
import { TextType } from '../TextType';

import * as S from './MediaAndBottomTextType.styles';

export const MediaAndBottomTextType = (_props: CardProps) => {
  const props: CardProps = {
    contentAlignment: 'center',
    textAlignment: 'center',
    type: 'default',
    urlType: 'button',
    ...cleanObject(_props),
  };
  const { deviceType } = useDeviceDetect();

  const backgroundColor = {
    ...props?.backgroundColor,
    value: props?.backgroundColor?.value || theme.colors.white,
  };
  const headingTextColor = theme.colors.default;
  const processedProps = {
    ...props,
    backgroundColor,
    headingTextColor,
  };
  const hasMedia = !!(
    props.media?.image?.url ??
    props.media?.imageMobile?.url ??
    props.media?.video?.url ??
    props.media?.videoMobile?.url
  );

  return (
    <S.Container
      $backgroundColor={hasMedia ? 'transparent' : backgroundColor.value}
      $visibleInDesktop={_props.visibleInDesktop}
      $visibleInMobile={_props.visibleInMobile}
      className={_props.className}
      data-test-id='MediaAndBottomTextTypeContainer'
    >
      {hasMedia && (
        <S.MediaWrapper
          $aspectRatio={getAspectRatioForImages(
            props.mediaWrapperType,
            props.cardGroupType,
            null,
            null,
            deviceType,
          )}
          $mediaAnimationEffect={
            processedProps.mediaAnimationEffect === 'zoomOnHover'
              ? processedProps.mediaAnimationEffect
              : null
          }
        >
          <S.Media $backgroundAlignment={props.backgroundAlignment}>
            <MediaWrapper
              {...(props.media as ContentfulImageWithFocalPointFragment)}
              aspectRatio={props.aspectRatio}
              cardGroupType={
                _props.cardGroupType as MediaWrapperContainerTypeEnum
              }
              data-test-id='MediaAndBottomTextBackgroundImage'
              mediaWrapperType={_props.mediaWrapperType}
              preload={props.preload}
              sizes='(max-width: 600px) 50vw, 100vw'
            />
          </S.Media>
        </S.MediaWrapper>
      )}
      <TextType
        {...processedProps}
        data-test-id='MediaAndBottomTextTypeTextType'
      />
    </S.Container>
  );
};
